import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import {
    IJob,
    JobSource,
    JobState,
} from '@models';
import { JobService } from '@services';

import { JobTriggerBaseComponent } from './job-trigger-base.component';

@Component({
    selector: 'ui-job-trigger-job',
    templateUrl: './job-trigger-job.component.html',
    styleUrls: ['./job-trigger-job.component.scss'],
    providers: [JobService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobTriggerJobComponent extends JobTriggerBaseComponent<IJob> {

    public JobState = JobState;
    public JobSource = JobSource;

    constructor(private _jobService: JobService) {
        super();
    }

    protected _fetchItem = () => this._jobService.getInstance(this._itemId, ['Robot', 'Release']);
}
